<template>
	<div class="team-detail-contact-extra">
		<div class="row g-4 align-items-center">
			<div class="col-md-5">
				<NuxtImg :src="completeImageUrl(contact.SpeakerImage)"
                 class="w-100"
                 :alt="contact.SpeakerImageMetadata['alt']"
                 :title="contact.SpeakerImageMetadata['title']"
                 loading="lazy"
                 sizes="1360px"
        />
			</div>
			<div class="col-md-7">
				<TeamDetailGetinTouch :contact="contact" />
			</div>
		</div>
	</div>
</template>

<script>
import TeamDetailGetinTouch from './TeamDetailGetinTouch'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	name: 'TeamDetailGetinTouchExtra',
	components: {
		TeamDetailGetinTouch
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact'],
  methods: {
    completeImageUrl(imagePath) {
      if (!imagePath) {
        return '/images/no-image-placeholder.svg'
      }
      return usePimcoreAssetUrl(imagePath)
    }
  }
}
</script>
<style lang="scss">
.team-detail-contact-extra {
	.contact-data {
		margin-bottom: 2rem;
		li {
			display: flex;
			align-items: center;
			gap: 20px;
			margin-bottom: 1rem;
			a {
				color: $white;
				&:hover {
					color: $green;
				}
			}
		}

		&-flex {
			@include media-breakpoint-up(lg) {
				display: flex;
				gap: 20px;
			}
		}
	}
}
</style>
